import React, { useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input, Select, Textarea } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createTableDescription } from '../../actions/datasets'

const validationSchema = Yup.object({
  dsname: Yup.string().required('обязательное поле'),
  dstranslate: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  dsdescript: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode }) {

  const dispatch = useDispatch()

  const { datasetsAllList } = useSelector(state => state.datasets)
  const handleCreate = (values) => {
    dispatch(createTableDescription({ translate: values.dstranslate, descript: values.dsdescript, table_name: values.dsname }))
    closeModal()
  }

  const handleUpdate = (values) => {
    closeModal()
  }
  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >

            <div className={styles.inputsRow}>
              <Select
                label='Таблица'
                name='dsname'
                value={values.dsname}
                // error={error('rachid')}
                onChange={(e) => setFieldValue('dsname', e.target.value)}>
                <option selected={values.dsname === ''} value={''}>Выберите предмет</option>
                {datasetsAllList?.map((item) => <option key={item.table_name} value={item.table_name} selected={item.table_name === values.dsname}>{item.table_name}</option>)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Наименование'
                name='dstranslate'
                value={values.dstranslate}
                error={error('dstranslate')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                label=' Описание'
                name='dsdescript'
                value={values.dsdescript}
                error={error('dsdescript')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>

          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
